import { createContext, useContext } from 'react';

export type HeaderSize = 'lg' | 'md' | 'sm';

export interface HeaderContextValue {
  size: HeaderSize;
}

export const HeaderContext = createContext<HeaderContextValue | null>(null);

/** Lets sub-components read the size without it being threaded down. */
export function useHeaderContext(): HeaderContextValue {
  const context = useContext(HeaderContext);

  if (!context) {
    throw new Error(
      'Header sub-components must be rendered inside a <Header>.'
    );
  }

  return context;
}
